import { Card } from '@ss/meta-core-components'
import React from 'react'
import { IGenericObject } from '@types'
import { StatisticsIcon } from '../../assets/icons/statisticsIcon'
import styled from '@emotion/styled'

import { ReactComponent as Green } from '../../assets/img/greenArrow.svg'
import { ReactComponent as Red } from '../../assets/img/redArrow.svg'

interface Props {
  data: IGenericObject[]
  type: 'npm' | 'rr'
  name: string
}

/**
 * Componente Generico tabella economica della pagina time series
 * @param type {'npm' | 'rr'} tipo di tabella
 * @param data {IGenericObject} parametri per la richiesta dei dati
 * @param name {string} nome startUp
 * @component
 */
export const EconomicTable: React.FC<Props> = ({ type, name, data }) => {
  const getColor = (value?: number) => {
    if (!value) return undefined
    if (value > 0) return '#219653'
    return '#DB5126'
  }

  const getArrow = (value?: number) => {
    if (!value) return <></>
    if (value > 0) return <Green />
    return <Red />
  }

  return (
    <Card width={'49.5%'} dataCy={`${type}`}>
      <Title>
        <div style={{ placeSelf: 'center' }}>
          <StatisticsIcon />
        </div>
        <div data-cy={`${type}-title`}>
          {`${
            type === 'npm' ? 'Net Profit Margin' : 'Retention Ratio'
          } for company ${name}`}
        </div>
      </Title>
      <TableContainer data-cy={`${type}-table`}>
        <Row>
          <Cell></Cell>
          <Cell capitalize>{type}</Cell>
          <Cell> To year before</Cell>
          <Cell> To average settore</Cell>
        </Row>
        {data && Array.isArray(data) ? (
          data.map((d, index) => (
            <Row key={`${type}-${index}`}>
              <Cell>{d.anno}</Cell>
              <Cell>{d[type]}</Cell>
              <Cell
                data-cy={`${type}_prev-${index}`}
                dataColor={getColor(d[`${type}_prev`])}
              >
                <IconContainer>{getArrow(d[`${type}_prev`])}</IconContainer>{' '}
                {typeof d[`${type}_prev`] === 'number'
                  ? d[`${type}_prev`]
                  : '-'}
              </Cell>
              <Cell
                data-cy={`${type}_avg-${index}`}
                dataColor={getColor(d[`${type}_avg`])}
              >
                <IconContainer>{getArrow(d[`${type}_avg`])}</IconContainer>{' '}
                {typeof d[`${type}_avg`] === 'number' ? d[`${type}_avg`] : '-'}
              </Cell>
            </Row>
          ))
        ) : (
          <></>
        )}
      </TableContainer>
    </Card>
  )
}

//region STYLE
const Title = styled.div`
  width: 100%;
  font-weight: 500;
  font-size: 18.022px;
  line-height: 22px;
  padding-bottom: 10px;
  display: grid;
  grid-template-columns: 45px auto;
  gap: 30px;
`
const TableContainer = styled.div`
  display: grid;
  width: 100%;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 100%;
`
const Cell = styled.div<{ dataColor?: string; capitalize?: boolean }>`
  place-self: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 27px;
  ${({ dataColor }) => dataColor && `color:${dataColor}`};
  ${({ capitalize }) => capitalize && 'text-transform: uppercase'};
  display: grid;
  grid-template-columns: auto auto;
  gap: 10px;
`
const IconContainer = styled.div`
  width: 15px;
  place-self: center;
`

//endregion
